
import { useState } from "react";

interface FilterState {
  ageMin: number;
  ageMax: number;
  maxDistance: number;
  onlineOnly: boolean;
  withPhotoOnly: boolean;
  lookingFor: string[];
}

const defaultFilters: FilterState = {
  ageMin: 18,
  ageMax: 99,
  maxDistance: 0, // Set to 0 to disable distance filtering by default
  onlineOnly: false,
  withPhotoOnly: false,
  lookingFor: []
};

export const useDiscoveryFilters = () => {
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState<FilterState>(defaultFilters);

  // Check if any filters are active (different from defaults)
  const hasActiveFilters = 
    filters.ageMin !== defaultFilters.ageMin ||
    filters.ageMax !== defaultFilters.ageMax ||
    filters.maxDistance !== defaultFilters.maxDistance ||
    filters.onlineOnly !== defaultFilters.onlineOnly ||
    filters.withPhotoOnly !== defaultFilters.withPhotoOnly ||
    filters.lookingFor.length > 0;

  return {
    showFilters,
    setShowFilters,
    filters,
    setFilters,
    hasActiveFilters
  };
};
